import React from 'react';
import { Banner } from '@cad-arc';

export const MessageLoadFailBanner = ({
    testId,
    description,
    isError,
    refetch,
}: {
    testId?: string;
    description?: string;
    isError?: boolean;
    refetch?: () => void;
}) => {
    if (isError) {
        return (
            <Banner
                actions={[
                    {
                        children: 'Retry',
                        variant: 'solid',
                        onClick: () => {
                            refetch?.();
                        },
                        'data-testid': testId ?? 'conversation-messages-load-retry',
                    },
                ]}
                description={description ?? 'An error occurred while loading messages.'}
                status="error"
            />
        );
    }
    return <></>;
};
